<template>
    <div class="view pa24">
        <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
            :close-on-click-modal="false" :before-close="closeDialog">
            <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="130px" class="ruleForm">
                <!-- 设备选择 -->
                <el-form-item label="经销商选择" prop="devices">
                    <el-select v-model="ruleForm.dealerId" placeholder="请选择经销商" @change="chooseDearler"
                        :remote-method="remoteMethod" :loading="loading">
                        <el-option v-for="dealer in dealerList" :key="dealer.id" :label="dealer.dealerName"
                            :value="dealer.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="设备选择" prop="devices">
                    <el-select v-model="ruleForm.devices" placeholder="请选择设备" multiple collapse-tags
                        collapse-tags-tooltip @change="getHistoryParams">
                        <el-option v-for="item in deviceList" :key="item.id" :label="item.deviceName" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button type="primary" class="selectAll" @click="selectAll">全选</el-button>
                </el-form-item>
                <!-- 定位频次设置 -->
                <el-form-item label="设备的接收频率" prop="frequency">
                    <el-input-number v-model="ruleForm.frequency" :min="1" :max="1440"
                        :controls="false"></el-input-number>分
                    <br>
                    <span>设备的发射频率区间在1-1440分钟/次，默认为240分钟/次</span>
                </el-form-item>
                <!-- 历史参数设置 -->
                <el-form-item label="历史参数设置" v-if="historyParams">
                    <div v-if="historyParams.length === 0">暂无数据</div>
                    <div v-else class="table-container">
                        <el-table :data="historyParams" style="width: 100%" height="400">
                            <el-table-column prop="deviceName" label="设备名称" />
                            <el-table-column prop="description" label="描述" />
                            <el-table-column prop="username" label="操作人" />
                            <el-table-column prop="createTime" label="设置时间" />
                        </el-table>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { getDeviceList, parameter, getDearler, getNoPage, getDeviceLog } from '@/api/gps.js'
    import { fetchDealList } from '@/api/companyManage.js'
    export default {
        data() {
            return {
                dialogVisible: false,
                title: '参数设置',
                ruleForm: {
                    devices: [],
                    frequency: '240'
                },
                rules: {
                    devices: [
                        { required: true, message: '请选择设备', trigger: 'blur' }
                    ],
                    frequency: [
                        { required: true, message: '请输入定位频次', trigger: 'blur' }
                    ]
                },
                deviceList: [],
                dealerList: [],
                dealerId: null,
                historyParams: [],
                loading: false
            };
        },
        mounted() {
            // this.getDeviceList()
            this.getDealerList()
        },
        methods: {
            remoteMethod(query) {
                if (query !== '') {
                    this.dealerList = []
                    this.loading = true;
                    this.getDealerList(query)
                } else {
                    this.dealerList = [];
                }
            },
            selectAll() {
                this.ruleForm.devices = []
                this.deviceList.forEach(item => {
                    this.ruleForm.devices.push(item.id);
                })
            },
            openDialog(type, data) {
                this.ruleForm = {
                    devices: [],
                    frequency: 240
                };
                this.historyParams = []
                this.dialogVisible = true;


            },
            closeDialog() {
                this.dialogVisible = false;
                this.historyParams = []
            },
            confirmAddDealer() {
                this.$refs.dealerRuleForm.validate((valid) => {
                    if (valid) {
                        // 构建params
                        let params = {
                            deviceIds: this.ruleForm.devices,
                            frequency: this.ruleForm.frequency,
                        }
                        parameter(params).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '设置成功'
                                })
                                this.closeDialog()
                                this.getDeviceList()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            getDeviceList() {
                getNoPage().then(res => {
                    console.log("res" + res);
                    this.deviceList = res.data
                    console.log(this.deviceList);
                })
            },

            getDealerList(dealerName) {
                this.loading = false
                let params = {
                    pageNum: 1,
                    pageSize: 200,
                    dealerName
                }
                fetchDealList(params).then((res) => {
                    if (res.data) {
                        this.dealerList = res.data.list;
                    }
                    this.$nextTick(function () {
                        this.initMapWithData();
                    });
                });
            },
            chooseDearler() {
                this.deviceId = null
                this.ruleForm.devices = []
                this.historyParams = null; // 清空历史参数设置
                getDearler({ dealerId: this.ruleForm.dealerId }).then(res => {
                    if (res.data) {
                        this.loading = false
                        this.deviceList = res.data
                        // 把所有的设备id收集起来
                        let deviceIds = this.deviceList.map(item => item.id)
                        console.log(deviceIds);
                        if (!this.ruleForm.devices || this.ruleForm.devices.length === 0) {
                            this.ruleForm.devices = deviceIds;
                        }

                        this.getHistoryParams(); // 获取历史参数设置
                    }
                })
            },
            getHistoryParams() {
                console.log('选择的设备ID:', this.ruleForm.devices);

                getDeviceLog({
                    deviceIds: this.ruleForm.devices
                }).then(res => {
                    if (res.data) {
                        this.historyParams = res.data;
                        console.log(this.historyParams);
                    }
                });
            }
        }
    };

</script>
<style lang="scss" scoped>
    .selectAll {
        margin-left: 15px;
    }

    .el-select {
        width: 260px !important;
    }

    /deep/ .el-select .el-select__tags {
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        white-space: normal !important;
        display: flex;
        flex-wrap: wrap;
    }

    /deep/ .el-select .el-input__inner {
        height: auto !important;
        line-height: normal !important;
        padding: 5px;
    }
</style>